import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import useStyles from './styles';
import { AvailabilityProps } from './interfaces/AvailabilityProps';

const RBIDropdownSelector = (props: AvailabilityProps) => {
  const classes = useStyles();
  const {
    options,
    selected,
    handleChangeSelect,
    name,
    extraOption,
    extraOptionValue,
    isDisabled = false,
  } = props;
  const onSelectorChange = event => {
    handleChangeSelect(event.target.value);
  };
  return (
    <FormControl
      fullWidth
      className={classes.formControl}
      size="small"
      variant="outlined"
      disabled={isDisabled}
    >
      <InputLabel id="demo-simple-select-outlined-label">{name}</InputLabel>
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={selected}
        onChange={onSelectorChange}
        label={name}
        fullWidth
      >
        {extraOption && (
          <MenuItem value={extraOptionValue}>
            <em>{extraOption}</em>
          </MenuItem>
        )}
        {options?.map(el => (
          <MenuItem key={el.id} value={el.id}>
            {el.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default RBIDropdownSelector;
